import { render, staticRenderFns } from "./@GenerateReportNew.vue?vue&type=template&id=818cb4da&scoped=true&"
import script from "./@GenerateReportNew.vue?vue&type=script&lang=js&"
export * from "./@GenerateReportNew.vue?vue&type=script&lang=js&"
import style0 from "./@GenerateReportNew.vue?vue&type=style&index=0&id=818cb4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818cb4da",
  null
  
)

export default component.exports